/* eslint-disable */
// This file is generated by dev/generateInitialLangFallback.ts. Do not edit it manually.

import type { LangPackStringValue } from '../../api/types';
import type { LangKey } from '../../types/language';

export default {
  "LachesisCrmTitle": "Lachesis CRM",
  "LachesisCrmIdentity": "Operated by Moirae. Independent third-party client. Not affiliated with, endorsed by, or operated by Telegram. / Moirae 运营的独立第三方客户端，非 Telegram 官方服务。",
  "LachesisCrmPurpose": "This client uses the Telegram API for business messaging, embedded translation and team account management in Lachesis CRM. / 本客户端通过 Telegram API 提供业务沟通、内嵌翻译和团队账号管理。",
  "LachesisCrmData": "Inside the Lachesis desktop app, enabled CRM features can archive account identity, contacts, chat history, messages and media to your organization’s backend for access by authorized CRM administrators. Translation and AI features can send selected content to configured providers. / 在桌面应用内，已启用的 CRM 功能可将账号身份、联系人、聊天历史、消息及媒体归档至组织后端，供获授权的管理员访问；翻译及 AI 功能可向配置的服务商发送选定内容。",
  "LachesisCrmSession": "Signing in grants this client access to your account and cloud chats. Use only accounts you own or are authorized to manage. Review retention and deletion with your CRM administrator. Revoke sessions in Telegram Settings → Devices. This does not delete existing CRM archives. / 登录将授权客户端访问账号和云端聊天。仅使用本人或获授权管理的账号；保留与删除政策请咨询 CRM 管理员。在 Telegram 设置 → 设备中可撤销会话，但不会删除已有 CRM 归档。",
  "LachesisCrmDetails": "CRM purpose & data handling / 用途与数据处理",
  "LachesisCrmOfficial": "Official Telegram Web / Telegram 官方网页版",
  "LachesisCrmConsent": "I am authorized to use this account and understand the third-party CRM data handling described above. / 我已获授权使用此账号，并了解上述第三方 CRM 数据处理方式。",
  "LachesisCrmContinue": "Continue to CRM sign-in / 继续 CRM 登录",
  "LachesisCrmPhone": "Connect an authorized account to Lachesis CRM. / 将获授权的账号连接至 Lachesis CRM。",
  "LachesisCrmQr": "Connect to Lachesis CRM / 连接 CRM",
  "WrongNumber": "Wrong number?",
  "SentAppCode": "We've sent the code to the **Telegram** app on your other device.",
  "LoginJustSentSms": "We've sent you a code via SMS. Please enter it above.",
  "LoginHeaderPassword": "Enter Password",
  "LoginEnterPasswordDescription": "You have Two-Step Verification enabled, so your account is protected with an additional password.",
  "StartText": "Please confirm your country code\nand enter your phone number.",
  "LoginPhonePlaceholder": "Your phone number",
  "LoginNext": "Next",
  "LoginQRLogin": "Log in by QR Code",
  "LoginQRTitle": "Log in to Telegram by QR Code",
  "LoginQRHelp1": "Open Telegram on your phone",
  "LoginQRHelp2": "Go to **Settings** > **Devices** > **Add Device**",
  "LoginQRHelp3": "Point your phone at this screen to confirm login",
  "LoginQRCancel": "Log in by phone number",
  "LoginPasskey": "Log in with Passkey",
  "YourName": "Your Name",
  "LoginRegisterDesc": "Enter your name and add a profile photo.",
  "LoginRegisterFirstNamePlaceholder": "First Name",
  "LoginRegisterLastNamePlaceholder": "Last Name",
  "LoginSelectCountryTitle": "Country",
  "CountryNone": "Country not found",
  "PleaseEnterPassword": "Enter your new password",
  "ErrorPhoneNumberInvalid": "Invalid phone number, please try again",
  "ErrorCodeInvalid": "Invalid code, please try again",
  "ErrorIncorrectPassword": "Invalid password, please try again",
  "ErrorPasswordFlood": "Too many attempts, please try again later",
  "ErrorPhoneBanned": "This phone number is banned",
  "ErrorFloodTime": "Too many attempts, please try again in {time}",
  "ErrorUnexpected": "Unexpected error",
  "ErrorUnexpectedMessage": "Unexpected error: {error}"
} as Record<LangKey, LangPackStringValue>;
